export const isCanvasInactive = (
  event: (MouseEvent | TouchEvent) & { downElement: HTMLCanvasElement },
): boolean =>
  !event.downElement ||
  (event.downElement.nodeName !== 'CANVAS' &&
    event.downElement?.className !== 'tutorial-overlay-focus')
